<div class="mb-2">
  <canvas class="mb-2" #canvas
          (touchstart)="startDrawing($event)"
          (touchmove)="moved($event)"
          (pointerdown)="clearMessage($event)"
          width="700"
          height="200"></canvas>
  <p class="text-danger" *ngIf="signatureNeeded">Signature is required to save</p>

  <button class="mr-2 btn btn-bidit-cancel" (click)="clearPad()">Clear</button>
  <button class="btn btn-bidit-action" (click)="savePad()">Save signature</button>

</div>
